import React from 'react';
import { Tooltip } from '@material-ui/core';
import '../style.css';

const DatosExtra = ({ datosExtra }) => {
  const ref = React.useRef();

  const hasOverflow = React.useMemo(() => {
    let result = false;
    if (ref.current) {
      result = ref.current.offsetWidth < ref.current.scrollWidth;
    }
    return result;
  }, [ref.current]);

  // Cada línea "\n" se va a convertir en un salto de línea HTML
  const tooltipContent = (
    <React.Fragment>
      {datosExtra.split('\\n').map((line, index, arr) => (
        <React.Fragment key={index}>
          {line}
          {index < arr.length - 1 && <br />}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
  
  const child = React.useMemo(() => (
    <div className="datoExtra" ref={ref}>
      {datosExtra.replace(/\\n/g, ' ')}
    </div>
  ), [datosExtra]);

  return (
    <div>
      {hasOverflow ? <Tooltip title={tooltipContent} arrow>{child}</Tooltip> : child}
    </div>
  );
};

export default DatosExtra;
